<script lang="ts" setup>
const props = defineProps({
  showCounts: {
    type: Boolean,
    required: false,
    default: false,
  },
  allowUserEntered: {
    type: Boolean,
    required: false,
    default: false,
  },
  mode: {
    type: String,
    default: "single",
    validator: (value: string) => ["single", "tags"].includes(value),
  },
});

const jiraTickets = ref<JiraTicket[]>([]);
const isLoading = ref(false);

onMounted(async () => {
  isLoading.value = true;
  jiraTickets.value = await useJiraTickets().fetchJiraTickets(props.showCounts);
  isLoading.value = false;
});

const placeholder = computed(() => {
  return isLoading.value == true
    ? "Loading..."
    : "Choose or enter Jira identifier...";
});
</script>

<template>
  <BaseSelectInput
    :placeholder="placeholder"
    :options="jiraTickets"
    label="label"
    value-prop="identifier"
    :allow-user-entered="allowUserEntered"
    :mode="mode"
  />
</template>

<style scoped></style>
